import api from '@/plugins/api'

export function initStore(model) {
  return {
    namespaced: true,
    state: {
      items: [],
      item: {},
      totalCount: 0,
      query: [],
      loading: false
    },
    actions: {
      async fetch({ commit }, params) {
        const items = await api[model].fetch(params)
        commit('changeState', { items })
      },
      async fetchOne({ commit }, id) {
        const item = await api[model].fetchOne(id)
        commit('changeState', { item })
      },
      async count({ commit }, params) {
        const totalCount = await api[model].count(params)
        commit('changeState', { totalCount })
      },
      async create({ _ }, params) {
        const item = await api[model].create(params)
        return item
      },
      async update({ _ }, { id, ...params }) {
        await api[model].update(id, params)
      },
      async delete({ _ }, id) {
        await api[model].remove(id)
      }
    },
    mutations: {
      setState(state, { atr, value }) {
        state[atr] = value
      }
    }
  }
}
